import { Box } from '@mui/material';
import classNames from 'classnames';
import { PlayerTile } from 'modules/users/components/PlayerTile/PlayerTile';
import { useSearchUsers } from 'modules/users/hooks';
import React, { FC } from 'react';
import { SearchInput } from 'shared/components/SearchInput';
import { useDefaultUserMenuActions } from 'shared/hooks';
import { useStyles } from './Players.styles';

export const Players: FC = () => {
  const { classes } = useStyles();
  const { changeHandler, loading, users } = useSearchUsers();
  const { privateMessageActions, challengeActions } = useDefaultUserMenuActions();

  return (
    <div
      className={classNames(classes.root, 'tab-pane fade show active')}
      id="group"
      role="tabpanel"
      aria-labelledby="group-tab"
    >
      <div className="tab-body pt-2">
        <div className="form-group">
          <Box pl={1} pr={1}>
            <SearchInput
              placeholder="Search for players…"
              focusOnInit={true}
              onChange={changeHandler}
              loading={loading}
            />
          </Box>
        </div>
        <Box overflow="auto">
          {users.map((user) => (
            <Box key={user?.userId} className={classes.playerCard}>
              <PlayerTile user={user} actions={[...privateMessageActions, ...challengeActions]} />
            </Box>
          ))}
        </Box>
      </div>
    </div>
  );
};
